var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsumptionManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Consumption-management",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.995,
    height: 41.129,
    viewBox: "0 0 40.995 41.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M278.149,103.09h-34.2a3.4,3.4,0,0,0-3.4,3.4V136a3.4,3.4,0,0,0,3.4,3.4H262.28l4.819,4.819,4.537-4.543-.276-.276h6.788a3.4,3.4,0,0,0,3.4-3.4V119.147h-2.108V136a1.29,1.29,0,0,1-1.288,1.288h-8.894l-5.208-5.207-1.525,1.525-.97-.971a9.658,9.658,0,0,0,.61-.852h.691V130.5a9.638,9.638,0,0,0,0-7.841V118.9h-2.108v.736a9.679,9.679,0,1,0-.682,14.491l.97.971-1.525,1.525.669.669H243.947a1.289,1.289,0,0,1-1.288-1.288V113.163h37.364v-.021h1.523v-6.656A3.4,3.4,0,0,0,278.149,103.09Zm-29.5,28.847a7.574,7.574,0,1,1,12.1-8.807v.171h.081a7.571,7.571,0,0,1-12.177,8.634Zm20.012,7.739-1.562,1.558-4.61-4.609,1.56-1.56Zm-26-33.19a1.289,1.289,0,0,1,1.288-1.288h34.2a1.29,1.29,0,0,1,1.288,1.288v4.568H242.658Z",
    transform: "translate(-240.55 -103.09)",
    fill: "#ec0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 2.108,
    height: 2.034,
    transform: "translate(38.887 11.987)",
    fill: "#ec0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.874,
    height: 2.108,
    transform: "translate(4.1 3.748)",
    fill: "#ec0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 1.874,
    height: 2.108,
    transform: "translate(7.848 3.748)",
    fill: "#ec0000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 1.874,
    height: 2.108,
    transform: "translate(11.596 3.748)",
    fill: "#ec0000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 8.199,
    height: 2.108,
    transform: "translate(28.462 3.748)",
    fill: "#ec0000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 2.108,
    height: 1.718,
    transform: "translate(8.012 21.435)",
    fill: "#ec0000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 2.108,
    height: 3.904,
    transform: "translate(8.012 24.793)",
    fill: "#ec0000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 2.108,
    height: 1.054,
    transform: "translate(12.228 19.561)",
    fill: "#ec0000"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 2.108,
    height: 1.367,
    transform: "translate(12.228 21.552)",
    fill: "#ec0000"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 2.108,
    height: 4.347,
    transform: "translate(12.228 24.351)",
    fill: "#ec0000"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 2.108,
    height: 1.301,
    transform: "translate(16.445 18.39)",
    fill: "#ec0000"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 2.108,
    height: 1.367,
    transform: "translate(16.445 20.889)",
    fill: "#ec0000"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 2.108,
    height: 4.998,
    transform: "translate(16.445 23.7)",
    fill: "#ec0000"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 2.108,
    height: 1.562,
    transform: "translate(24.41 15.345)",
    fill: "#ec0000"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 2.108,
    height: 2.603,
    transform: "translate(24.41 18.012)",
    fill: "#ec0000"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 2.108,
    height: 6.676,
    transform: "translate(24.41 22.021)",
    fill: "#ec0000"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 2.108,
    height: 1.406,
    transform: "translate(28.626 14.408)",
    fill: "#ec0000"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 2.108,
    height: 2.577,
    transform: "translate(28.626 17.219)",
    fill: "#ec0000"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 2.108,
    height: 7.522,
    transform: "translate(28.626 21.175)",
    fill: "#ec0000"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 2.108,
    height: 1.301,
    transform: "translate(32.375 12.534)",
    fill: "#ec0000"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 2.108,
    height: 2.902,
    transform: "translate(32.375 15.11)",
    fill: "#ec0000"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 2.108,
    height: 9.136,
    transform: "translate(32.375 19.561)",
    fill: "#ec0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumptionManagement);
export default __webpack_public_path__ + "static/media/Consumption-management.08cce4c817e68a59d24d0308ba37d452.svg";
export { ForwardRef as ReactComponent };